// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/mini-css-extract-plugin/dist/loader.js??ref--9-oneOf-3-0!../../../../../node_modules/css-loader/dist/cjs.js??ref--9-oneOf-3-1!../../../../../node_modules/postcss-loader/src/index.js??ref--9-oneOf-3-2!../../../../../node_modules/sass-loader/dist/cjs.js??ref--9-oneOf-3-3!./oceanic.scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("44f2bb28", content, true, {"injectType":"styleTag","attributes":{"data-theme":"oceanic"}});